var _defs, _path, _path2, _path3, _circle, _circle2, _circle3, _circle4, _circle5, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _circle6, _circle7, _circle8, _circle9, _circle10, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGaming(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1c1c1c;}.cls-2{fill:#2b2b2b;}.cls-3{fill:gray;}.cls-4{fill:#606060;}.cls-5{fill:#494949;}.cls-6{fill:#333;}.cls-7{fill:#161616;}.cls-8{fill:#1e1e1e;}.cls-9{fill:#a31b00;}.cls-10{fill:#ce9334;}.cls-11{fill:#ffcf36;}.cls-12{fill:#588903;}.cls-13{fill:#0272aa;}.cls-14{fill:#8bb720;}.cls-15{fill:#2499ce;}.cls-16{fill:#e84215;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M499.15,350.7c-2.57-17.16-29.38-153.22-35.81-182.17S433.75,120.39,413,112.88s-45,1.93-63.26,0a168,168,0,0,1-37-7.61c-10.51-3.22-24.61-9.53-34.64-12s-24-2.84-27.6-2.89h-.92c-3.64,0-17.53.4-27.6,2.89s-24.13,8.79-34.64,12a168,168,0,0,1-37,7.61c-18.22,1.93-42.46-7.5-63.26,0s-44,26.7-50.39,55.65S3.42,333.54.85,350.7.63,389.94,21,401.52,72.69,414.38,88.55,391s50.93-88,51.9-89.53,1.71-1,1.71-1c2.15,3.43,16.09,20.37,41.6,19.08s35-16.94,41.82-25.73c5.94-7.61,20.23-8.15,24-8.16h.92c3.73,0,18,.55,24,8.16,6.86,8.79,16.3,24.45,41.81,25.73s39.46-15.65,41.61-19.08c0,0,.75-.54,1.71,1s36,66.16,51.9,89.53S458.62,413.1,479,401.52,501.73,367.85,499.15,350.7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.74,406.94a56,56,0,0,0,27.18,1.82c15.09-2.74,22.42-11,24.65-13.84s11-15.67,23-36.66,31.9-56.78,31.9-56.78,1.07-1.34,1.71-1c0,0-2.89-6.22-5.63-21.5s-3.86-22.19-3.86-22.19-.48,19-1.93,27.82S76.06,384.9,63.84,398.55,33.74,406.94,33.74,406.94Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.66,168.53S4.28,322.82.85,350.7s6.3,40.22,11.91,44.71c0,0-7.78-6.22-7.94-29.06S22,252.92,28,217.1,36.66,168.53,36.66,168.53Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 184.25,
    cy: 251.46,
    r: 33.13
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 184.25,
    cy: 244.95,
    r: 33.13,
    transform: "translate(-78.43 87) rotate(-22.03)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 184.25,
    cy: 239.97,
    r: 33.13
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 180.18,
    cy: 237.45,
    r: 21.75
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 110.1,
    cy: 180.21,
    r: 51.56
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M122.69,135.71a50.27,50.27,0,0,0-26.87.66s-1.81.34-1.65,2.75,4.4,21.83,5.76,26.42,7.79,11,10.52,11.09,8.61-6.78,9.79-11.71,3.88-26.64,3.88-26.64A2.57,2.57,0,0,0,122.69,135.71Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M110.48,172.76c-.75,0-6.55-8.43-6.75-9.54-.27-1.5.59-2.09,1.23-2.15s10-.1,10.51,0a1.72,1.72,0,0,1,1.24,1.88C116.7,164,111.56,172.76,110.48,172.76Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M110.67,170.24c-.51,0-4.48-5.77-4.62-6.53-.18-1,.41-1.43.85-1.47s6.86-.07,7.19,0a1.16,1.16,0,0,1,.84,1.29C114.93,164.22,111.41,170.24,110.67,170.24Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M123,223.57a50.36,50.36,0,0,1-26.88-.65s-1.8-.34-1.64-2.75,4.39-21.84,5.76-26.42,7.78-11,10.52-11.1,8.61,6.78,9.79,11.72S124.4,221,124.4,221A2.54,2.54,0,0,1,123,223.57Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M110.76,186.53c-.74,0-6.55,8.43-6.75,9.54-.26,1.5.59,2.09,1.24,2.14s10,.11,10.5,0a1.7,1.7,0,0,0,1.24-1.87C117,195.32,111.84,186.52,110.76,186.53Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M111,189c-.5,0-4.48,5.78-4.61,6.54-.19,1,.4,1.43.84,1.46s6.86.08,7.19,0a1.16,1.16,0,0,0,.85-1.28C115.22,195.06,111.69,189,111,189Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M154.52,191.62a50.4,50.4,0,0,0-.73-26.88s-.34-1.8-2.75-1.63-21.82,4.44-26.4,5.82-11,7.81-11.07,10.55,6.8,8.59,11.73,9.76S152,193.05,152,193.05A2.55,2.55,0,0,0,154.52,191.62Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M117.44,179.49c0-.74,8.42-6.57,9.53-6.77,1.5-.27,2.09.59,2.14,1.23s.14,10,0,10.51a1.7,1.7,0,0,1-1.87,1.24C126.25,185.7,117.44,180.57,117.44,179.49Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M120,179.68c0-.51,5.76-4.5,6.52-4.63,1-.19,1.43.4,1.47.84s.09,6.86,0,7.19a1.17,1.17,0,0,1-1.28.85C126,183.93,120,180.42,120,179.68Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M66.66,192.55a50.29,50.29,0,0,1,.59-26.87s.33-1.81,2.75-1.66,21.84,4.34,26.43,5.7,11,7.75,11.12,10.49-6.76,8.62-11.69,9.82S69.23,194,69.23,194A2.55,2.55,0,0,1,66.66,192.55Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M103.68,180.24c0-.74-8.45-6.53-9.56-6.72-1.5-.27-2.09.59-2.14,1.24s-.08,10,0,10.5a1.71,1.71,0,0,0,1.88,1.24C94.9,186.49,103.68,181.32,103.68,180.24Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M101.16,180.44c0-.51-5.78-4.47-6.54-4.6-1-.18-1.43.41-1.47.85s-.06,6.86,0,7.19a1.15,1.15,0,0,0,1.28.84C95.15,184.72,101.16,181.18,101.16,180.44Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M134.78,112.55s31.4,11.48,40.62,41.29,4.78,47,4.78,47,24.71-2.79,42.24,17.53,7.72,51.68,5.63,57a36.06,36.06,0,0,1,9.77-4.91c5.59-1.76,12.64-1.36,12.64-1.36A115.29,115.29,0,0,0,231.75,271s4.75-16.25,3.05-31c-1.93-16.76-12.78-28.2-21.55-33.59a58.52,58.52,0,0,0-29.71-8.74s3.76-19.68-6.21-45.41-31.79-35.81-35.65-37.34A72.51,72.51,0,0,0,134.78,112.55Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M158.43,139.26s-15.66-18.66-48.24-18.44-60.66,26.53-61.31,54.43S67.32,239,112.36,240.9c0,0-25.52,3.94-48.68-16.9s-25.41-60.94-5.15-82.65,41.66-24.93,62.4-22.92S158.43,139.26,158.43,139.26Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M466.26,406.94a56,56,0,0,1-27.18,1.82c-15.09-2.74-22.42-11-24.65-13.84s-11-15.67-23-36.66-31.9-56.78-31.9-56.78-1.07-1.34-1.71-1c0,0,2.89-6.22,5.63-21.5s3.86-22.19,3.86-22.19.48,19,1.93,27.82,54.68,100.25,66.9,113.9S466.26,406.94,466.26,406.94Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M463.34,168.53s32.38,154.29,35.81,182.17-6.3,40.22-11.91,44.71c0,0,7.78-6.22,7.94-29.06S478.05,252.92,472,217.1,463.34,168.53,463.34,168.53Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M313.45,298.8c-23.16-1-31.83-15.47-41.5-23.48-8-6.6-19.54-6.42-21.95-6.3-2.41-.12-14-.3-21.95,6.3-9.67,8-18.34,22.52-41.5,23.48s-45.57-8.58-53.88-42c0,0,4.67,33.72,9.49,43.69s25.87,21.65,44,18.92,25.84-9.25,30-14,7.31-9.25,10.6-12.89,9.51-6.22,23.23-6.8c13.72.58,20,3.21,23.23,6.8s6.41,8.12,10.6,12.89,11.93,11.28,30,14,39.15-8.95,44-18.92,9.49-43.69,9.49-43.69C359,290.22,336.61,299.77,313.45,298.8Z"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 315.75,
    cy: 251.46,
    r: 33.13
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 315.75,
    cy: 244.95,
    r: 33.13,
    transform: "translate(-80.72 295.01) rotate(-45)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 315.75,
    cy: 239.97,
    r: 33.13
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 310.49,
    cy: 237.45,
    r: 21.75
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 389.9,
    cy: 180.21,
    r: 51.56
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M322.52,130.64A70.78,70.78,0,0,0,290.05,105c-1.33-.5-2.68-1-4-1.42a112.85,112.85,0,0,0-71.14,0c-1.35.45-2.69.92-4,1.42a70.78,70.78,0,0,0-32.47,25.64,7.18,7.18,0,0,0,0,4.75c.93,2.37,15.87,45.59,15.87,45.59s3.55,8.29,14.61,8.06H292c11.07.23,14.61-8.06,14.61-8.06s14.94-43.22,15.87-45.59A7.11,7.11,0,0,0,322.52,130.64Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M365.22,112.55S333.82,124,324.6,153.84s-4.78,47-4.78,47-24.71-2.79-42.24,17.53-7.72,51.68-5.63,57a36.06,36.06,0,0,0-9.77-4.91c-5.59-1.76-12.64-1.36-12.64-1.36A115.29,115.29,0,0,1,268.25,271s-4.42-16.27-2.57-31,12.06-27.37,20.83-32.76a59.57,59.57,0,0,1,30-8.82s-3.54-21,6.44-46.69a65.93,65.93,0,0,1,35.38-36.81A72.51,72.51,0,0,1,365.22,112.55Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M341.57,139.26s15.66-18.66,48.24-18.44,60.66,26.53,61.31,54.43S432.68,239,387.64,240.9c0,0,25.52,3.94,48.68-16.9s25.41-60.94,5.15-82.65-41.66-24.93-62.4-22.92S341.57,139.26,341.57,139.26Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M367.33,256.83s-2.55,13-4.66,26.84-4.24,18.56-13.36,25.75-32.49,18-58.33,1.93c0,0,18.55,9.11,33.56,4.61s6.12-18.66,6.12-18.66,9.58-2.25,19.94-10.51C363.57,276.45,367.33,256.83,367.33,256.83Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M131.82,256.9s2.55,13,4.65,26.85,4.25,18.55,13.36,25.74,32.49,18,58.33,1.93c0,0-18.55,9.11-33.56,4.61s-6.11-18.66-6.11-18.66-9.59-2.25-20-10.51C135.57,276.52,131.82,256.9,131.82,256.9Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M219.32,283.63c5.18-5.1,8-8.7,15.06-12.05s29.66-4.51,37.35,3.15,12.29,12,12.29,12-15.34-15-18.88-10,4.75,13.18,4.75,13.18-3-3.95-16.16-4.65-24,3.52-26,6.4a56.29,56.29,0,0,0,6.12-6.87c2.85-3.7,2.74-7.37-1.89-8.38C227,275.32,219.32,283.63,219.32,283.63Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M319.82,127.46a67.6,67.6,0,0,0-31.46-23.16c-1.29-.45-2.59-.87-3.9-1.28a117,117,0,0,0-68.92,0c-1.31.41-2.61.83-3.9,1.28a67.6,67.6,0,0,0-31.46,23.16,6,6,0,0,0,0,4.29c.9,2.15,15.38,41.18,15.38,41.18s3.43,7.48,14.15,7.28h80.58c10.72.2,14.15-7.28,14.15-7.28s14.48-39,15.38-41.18A6,6,0,0,0,319.82,127.46Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M181.72,125.45l.45-.58C182,125.07,181.86,125.26,181.72,125.45Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M318.28,125.45c-.14-.19-.28-.38-.45-.58Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M319.82,127.46l-1.54-2a5,5,0,0,1,.69,4.43s-13.32,34.79-16.78,41.62S290.05,178,290.05,178l-39.59-.39h-.92L210,178s-8.68.32-12.14-6.52S181,129.88,181,129.88a5,5,0,0,1,.69-4.43l-1.54,2a5.45,5.45,0,0,0,0,4.29c1,2.48,15.38,41.18,15.38,41.18s3.05,7.28,14.15,7.28h80.58c11.1,0,14.15-7.28,14.15-7.28s14.42-38.7,15.38-41.18A5.45,5.45,0,0,0,319.82,127.46Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M212.09,107.15c-10.9,4.2-21.28,10.27-26.66,18.92,0,0,4.18,15,13.67,20.27,8.91,5,46.35,3.87,50.9,3.71,4.55.16,42,1.27,50.9-3.71,9.49-5.31,13.67-20.27,13.67-20.27-5.38-8.65-15.76-14.72-26.66-18.92A105.45,105.45,0,0,0,212.09,107.15Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M148.49,115.88s17.15,1.72,39.67-7.39,36.38-15.95,62.3-16.43,39.26,7,52.94,12.3a176.79,176.79,0,0,0,34.17,9.41c6.92,1,17.32.72,17.32.72s-19.62,8.36-23.16,7.72-42-27.34-81.27-27S183,118.08,172.72,124.87c0,0-4.34,2.49-10.45-.73C155,120.32,148.49,115.88,148.49,115.88Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M195.4,195.23s26,5,39.72,21.39,4,48.09,5.31,48.25,4.7-1.45,11.24-.89a69.48,69.48,0,0,1,10.07,1.69c.72,0-8.28-35.27,5.87-51.57s25.73-18.45,41.39-20.16c0,0-11.91.34-33.35,4.34s-31.95,3.38-52.54-.48S195.4,195.23,195.4,195.23Z"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 389.9,
    cy: 149.82,
    r: 16.78,
    transform: "translate(-24.15 204.84) rotate(-28.59)"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 389.9,
    cy: 210.33,
    r: 16.78,
    transform: "translate(112.91 556.08) rotate(-79.64)"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 389.9,
    cy: 208.12,
    r: 16.08
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 360.36,
    cy: 182.32,
    r: 16.78
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 420.24,
    cy: 182.32,
    r: 16.78
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 360.36,
    cy: 178.96,
    r: 16.08,
    transform: "matrix(0.53, -0.85, 0.85, 0.53, 17.99, 390.3)"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 420.24,
    cy: 179.56,
    r: 16.08,
    transform: "translate(94.17 499.75) rotate(-67.62)"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 389.9,
    cy: 147.41,
    r: 16.08
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGaming);
export default __webpack_public_path__ + "static/media/gaming.5d2ff25794b53cc12f45a69702d7bb06.svg";
export { ForwardRef as ReactComponent };